import { STYLE_DISCOVERY_PROVIDERS, STYLE_DISCOVERY_SEARCH_URLS } from './providers.js';

export const MAX_DISCOVERY_QUERY_LENGTH = 180;

export function buildDiscoveryUrl({ providerId, query }) {
  if (!STYLE_DISCOVERY_PROVIDERS[providerId] || typeof query !== 'string') return null;
  if (/\r|\n/.test(query)) return null;

  const normalizedQuery = query.trim();
  if (!normalizedQuery || normalizedQuery.length > MAX_DISCOVERY_QUERY_LENGTH) return null;

  const config = STYLE_DISCOVERY_SEARCH_URLS[providerId];
  const url = new URL(config.baseUrl);
  url.searchParams.set(config.queryParam, normalizedQuery);
  return url.toString();
}
